// extracted by mini-css-extract-plugin
module.exports = {"IconButton":"IconButton_IconButton__x8JrP","label":"IconButton_label__MjOPs"};